export default "__VITE_ASSET__ou78J736__"